<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconSupport_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M12.078 1.008c-5.243.207-9.642 4.433-10.046 9.664-.351 4.545 2.216 8.536 6.018 10.321a1.87 1.87 0 0 0 3.742-.081 1.874 1.874 0 0 0-3.208-1.317A9.05 9.05 0 0 1 4.018 14.5h1.619a7.54 7.54 0 0 0 2.881 3.347c.425-.198.898-.31 1.399-.31 1.149 0 2.161.577 2.77 1.454a7.5 7.5 0 0 0 6.682-4.491h1.997c.722 0 1.356-.511 1.48-1.223q.153-.867.154-1.777C23 5.57 18.059.773 12.078 1.008M8.214 9.839a1.339 1.339 0 1 1 2.678 0 1.339 1.339 0 0 1-2.678 0m7.67 5.057c-.053.059-1.335 1.448-3.384 1.448s-3.331-1.389-3.384-1.448a.75.75 0 1 1 1.111-1.007c.006.006.904.955 2.272.955s2.267-.949 2.275-.958a.754.754 0 0 1 1.058-.043.745.745 0 0 1 .052 1.053m-.438-3.717a1.339 1.339 0 1 1 0-2.678 1.339 1.339 0 0 1 0 2.678M19.849 10A7.5 7.5 0 0 0 12.5 4a7.5 7.5 0 0 0-7.349 6H3.622v-.003c.614-3.772 3.676-6.803 7.453-7.387 5.066-.782 9.496 2.694 10.289 7.39z"
    />
</svg>
